import { useMutation, useQueryClient, type UseMutationResult } from "@tanstack/react-query";
import type { ApiError } from "../../../types/apiResponse";
import { createClient, type CreateClientResponse } from "../api/createClient";
import type { ClientData } from "../types";
import withPrefix from "../../../helpers/useQueryPrefix";

export const useCreateClient = (): UseMutationResult<CreateClientResponse, ApiError, ClientData> => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: createClient,
        // Se retorna la promesa para que la lista de clientes ya esté refrescada
        // cuando corran los callbacks onSuccess de quien dispara la mutación.
        onSuccess: () => queryClient.invalidateQueries({ queryKey: withPrefix(['clients']) }),
    })
}
